import { ViewEditNarrativeFuturePEMultipleCalculator } from './ViewEditNarrativeFuturePEMultipleCalculator';
import type { Valuation } from '../../hooks/valuationFragment';

export class SponsoredFuturePEMultipleCalculator extends ViewEditNarrativeFuturePEMultipleCalculator {
  constructor(valuation: Valuation) {
    super(valuation);

    // Assume our in house financial analyst is always the source of truth
    this._sharesOutstandingGrowthRate =
      valuation.sharesOutstandingGrowthRate ?? 0;
  }
}
